import { useCallback, useState } from "react";

export default function useToggle(init) {
  const [value, setValue] = useState(!!init);
  const toggle = useCallback(() => setValue(v => !v), [setValue], []);

  return [value, toggle, setValue];
}
